import type { FC } from 'react';
import { Users } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { Guard, usePermissionGuard } from 'features/login';

const UsersPage: FC = () => {
  const { accessToViewUserprofile } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewUserprofile} fallback>
      <CabinetTitlePage title={'Users'} />
      <Users />
    </Guard>
  );
};

export default UsersPage;
